import theme from "../../../../styles/theme";

/* ============================================================================
BUILDING SYSTEMS — DEFINITION
Librairie Building pour AssetWorkbench
============================================================================ */

/* ============================================================================
META VISUEL
============================================================================ */

export const familyMeta = {

  foundations: {
    label: "Foundations",
    shortLabel: "Found.",
    color: theme.Generic.grey.dark.bg,
    lightBg: theme.Generic.grey.pastel.bg,
    lightBorder: theme.Generic.grey.pastel.border
  },

  structure: {
    label: "Structure",
    shortLabel: "Structure",
    color: theme.Generic.blue.dark.bg,
    lightBg: theme.Generic.blue.pastel.bg,
    lightBorder: theme.Generic.blue.pastel.border
  },

  floors: {
    label: "Floors",
    shortLabel: "Floors",
    color: theme.Generic.teal.dark.bg,
    lightBg: theme.Generic.teal.pastel.bg,
    lightBorder: theme.Generic.teal.pastel.border
  },

  roofing: {
    label: "Roofing",
    shortLabel: "Roof",
    color: theme.Generic.orange.dark.bg,
    lightBg: theme.Generic.orange.pastel.bg,
    lightBorder: theme.Generic.orange.pastel.border
  },

  facades: {
    label: "Facades",
    shortLabel: "Facade",
    color: theme.Generic.purple.dark.bg,
    lightBg: theme.Generic.purple.pastel.bg,
    lightBorder: theme.Generic.purple.pastel.border
  },

  openings: {
    label: "Openings",
    shortLabel: "Open.",
    color: theme.Generic.yellow.dark.bg,
    lightBg: theme.Generic.yellow.pastel.bg,
    lightBorder: theme.Generic.yellow.pastel.border
  },

  stairs: {
    label: "Stairs",
    shortLabel: "Stairs",
    color: theme.Generic.orange.dark.bg,
    lightBg: theme.Generic.orange.pastel.bg,
    lightBorder: theme.Generic.orange.pastel.border
  },

  partitions: {
    label: "Partitions",
    shortLabel: "Partitions",
    color: theme.Generic.green.dark.bg,
    lightBg: theme.Generic.green.pastel.bg,
    lightBorder: theme.Generic.green.pastel.border
  },

  floor_finishes: {
    label: "Floor finishes",
    shortLabel: "Floor",
    color: theme.Generic.teal.dark.bg,
    lightBg: theme.Generic.teal.pastel.bg,
    lightBorder: theme.Generic.teal.pastel.border
  },

  wall_finishes: {
    label: "Wall finishes",
    shortLabel: "Wall",
    color: theme.Generic.blue.dark.bg,
    lightBg: theme.Generic.blue.pastel.bg,
    lightBorder: theme.Generic.blue.pastel.border
  },

  ceilings: {
    label: "Ceilings",
    shortLabel: "Ceil.",
    color: theme.Generic.grey.dark.bg,
    lightBg: theme.Generic.grey.pastel.bg,
    lightBorder: theme.Generic.grey.pastel.border
  },

  external_works: {
    label: "External Works",
    shortLabel: "Ext.",
    color: theme.Generic.orange.dark.bg,
    lightBg: theme.Generic.orange.pastel.bg,
    lightBorder: theme.Generic.orange.pastel.border
  }

};

/* ============================================================================
FIELDS
============================================================================ */

function createCommonDetailFields() {

  return [

    {
      name: "status",
      label: "Status",
      control: "select",
      options: [
        { value: "planned", label: "Planned" },
        { value: "option", label: "Option" },
        { value: "validated", label: "Validated" }
      ]
    },

    {
      name: "notes",
      label: "Notes",
      control: "text"
    }

  ];

}

export const fieldSchema = {

  foundations:{
    summarySourceField:"quantity",
    quickFields:[
      {name:"quantity",label:"Qty",control:"number"},
      {name:"type",label:"Type",control:"text"}
    ],
    detailFields:createCommonDetailFields()
  },

  structure:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  floors:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  roofing:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  facades:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  openings:{
    summarySourceField:"count",
    quickFields:[
      {name:"count",label:"Qty",control:"stepper"}
    ],
    detailFields:createCommonDetailFields()
  },

  stairs:{
    summarySourceField:"count",
    quickFields:[
      {name:"count",label:"Qty",control:"stepper"}
    ],
    detailFields:createCommonDetailFields()
  },

  partitions:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  floor_finishes:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  wall_finishes:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  ceilings:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  },

  external_works:{
    summarySourceField:"surface",
    quickFields:[
      {name:"surface",label:"Surface",control:"number"}
    ],
    detailFields:createCommonDetailFields()
  }

};

/* ============================================================================
DEFAULT DATA
============================================================================ */

export const createDefaultBuildingSystems = () => [

{ id:"foundations-01",entityType:"BUILDING_SYSTEM",family:"foundations",title:"Foundations",subtitle:"Foundation system",active:true,unit:"m³",summaryValue:180,summaryLabel:"Volume",fields:{quantity:180,type:"Footings"} },

{ id:"structure-01",entityType:"BUILDING_SYSTEM",family:"structure",title:"Structure",subtitle:"Main structural system",active:true,unit:"m²",summaryValue:2400,summaryLabel:"Surface",fields:{surface:2400} },

{ id:"floors-01",entityType:"BUILDING_SYSTEM",family:"floors",title:"Floors",subtitle:"Structural floors",active:true,unit:"m²",summaryValue:2200,summaryLabel:"Surface",fields:{surface:2200} },

{ id:"roofing-01",entityType:"BUILDING_SYSTEM",family:"roofing",title:"Roofing",subtitle:"Roof system",active:true,unit:"m²",summaryValue:1100,summaryLabel:"Surface",fields:{surface:1100} },

{ id:"facades-01",entityType:"BUILDING_SYSTEM",family:"facades",title:"Facades",subtitle:"External envelope",active:true,unit:"m²",summaryValue:1600,summaryLabel:"Surface",fields:{surface:1600} },

{ id:"openings-01",entityType:"BUILDING_SYSTEM",family:"openings",title:"Openings",subtitle:"Doors and windows",active:true,unit:"u",summaryValue:86,summaryLabel:"Qty",fields:{count:86} },

{ id:"stairs-01",entityType:"BUILDING_SYSTEM",family:"stairs",title:"Stairs",subtitle:"Vertical circulation",active:false,unit:"u",summaryValue:4,summaryLabel:"Qty",fields:{count:4} },

{ id:"partitions-01",entityType:"BUILDING_SYSTEM",family:"partitions",title:"Partitions",subtitle:"Internal partitions",active:true,unit:"m²",summaryValue:900,summaryLabel:"Surface",fields:{surface:900} },

{ id:"floor-finishes-01",entityType:"BUILDING_SYSTEM",family:"floor_finishes",title:"Floor finishes",subtitle:"Floor finishing layers",active:true,unit:"m²",summaryValue:2100,summaryLabel:"Surface",fields:{surface:2100} },

{ id:"wall-finishes-01",entityType:"BUILDING_SYSTEM",family:"wall_finishes",title:"Wall finishes",subtitle:"Wall finishing layers",active:true,unit:"m²",summaryValue:3400,summaryLabel:"Surface",fields:{surface:3400} },

{ id:"ceilings-01",entityType:"BUILDING_SYSTEM",family:"ceilings",title:"Ceilings",subtitle:"False ceilings",active:false,unit:"m²",summaryValue:1800,summaryLabel:"Surface",fields:{surface:1800} },

{ id:"externalworks-01",entityType:"BUILDING_SYSTEM",family:"external_works",title:"External Works",subtitle:"Site infrastructure",active:false,unit:"m²",summaryValue:1500,summaryLabel:"Surface",fields:{surface:1500} }

];